// extracted by mini-css-extract-plugin
export default {"GetStarted":"GetStarted_GetStarted__0511F"};